import { c as _c } from "react/compiler-runtime";
import { addVote, attendVote, deleteVote, editVote, endVote, fetchVoteInfo, topFixedVote } from '@module/apis/client-side/vote';
import type { AddVoteParams, AddVoteResponse, AttendVoteParams, AttendVoteResponse, DeleteVoteParams, DeleteVoteResponse, EditVoteParams, EditVoteResponse, EndVoteParams, EndVoteResponse, GetVoteInfo, TopFixedVoteParams, TopFixedVoteResponse, VoteInfoParams } from '@module/apis/client-side/vote/type';
import { type UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { voteQueryKeys } from './voteQueryKeys';
export const useFetchVoteInfoQuery = (voteInfoParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== voteInfoParams) {
    t0 = voteQueryKeys.fetchVoteInfo(voteInfoParams);
    $[0] = voteInfoParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== voteInfoParams) {
    t1 = () => fetchVoteInfo(voteInfoParams);
    $[2] = voteInfoParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useAddVoteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = voteQueryKeys.addVote();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useEditVoteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = voteQueryKeys.editVote();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp2,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useAttendVoteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = voteQueryKeys.attendVote();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp3,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useEndVoteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = voteQueryKeys.endVote();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp4,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useDeleteVoteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = voteQueryKeys.deleteVote();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp5,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useTopFixedVoteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = voteQueryKeys.topFixedVote();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp6,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp(addVoteParams) {
  return addVote(addVoteParams);
}
function _temp2(editVoteParams) {
  return editVote(editVoteParams);
}
function _temp3(attendVoteParams) {
  return attendVote(attendVoteParams);
}
function _temp4(endVoteParams) {
  return endVote(endVoteParams);
}
function _temp5(deleteVoteParams) {
  return deleteVote(deleteVoteParams);
}
function _temp6(topFixedVoteParams) {
  return topFixedVote(topFixedVoteParams);
}